'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDeviceDetect = require('react-device-detect');

var _Label = require('../Label/Label');

var _Label2 = _interopRequireDefault(_Label);

var _Container = require('./components/Container.CheckBox');

var _Container2 = _interopRequireDefault(_Container);

var _Content = require('./components/Content.CheckBox');

var _Content2 = _interopRequireDefault(_Content);

var _IconContainer = require('./components/IconContainer.CheckBox');

var _IconContainer2 = _interopRequireDefault(_IconContainer);

var _Mark = require('./components/Mark.CheckBox');

var _Mark2 = _interopRequireDefault(_Mark);

var _Img = require('./components/Img.CheckBox');

var _Img2 = _interopRequireDefault(_Img);

var _check = require('./assets/check.png');

var _check2 = _interopRequireDefault(_check);

var _close = require('./assets/close.png');

var _close2 = _interopRequireDefault(_close);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components
// import Svg from './components/Svg.CheckBox';
// import Path from './components/Path.CheckBox';
// Images


var ExplicitCheckBox = function (_Component) {
  _inherits(ExplicitCheckBox, _Component);

  function ExplicitCheckBox() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ExplicitCheckBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ExplicitCheckBox.__proto__ || Object.getPrototypeOf(ExplicitCheckBox)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function () {
      var _this$props = _this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled;
      if (disabled) return;
      if (!value) return onChange('no');
      if (value === 'no') return onChange('yes');
      onChange(null);
    }, _this.eventHandlers = function () {
      return _reactDeviceDetect.isMobile ? {
        onTouchEnd: _this.onChange
      } : {
        onClick: _this.onChange
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ExplicitCheckBox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          children = _props.children,
          size = _props.size,
          disabled = _props.disabled,
          green = _props.green;
      return _react2.default.createElement(_Label2.default, {
        label: children
      }, _react2.default.createElement(_Container2.default, _extends({
        on: value === 'yes' ? 1 : 0,
        size: size,
        disabled: disabled,
        green: green
      }, this.eventHandlers()), _react2.default.createElement(_Content2.default, {
        value: value
      }, _react2.default.createElement(_IconContainer2.default, null), _react2.default.createElement(_IconContainer2.default, null, _react2.default.createElement(_Mark2.default, {
        size: size
      }, _react2.default.createElement(_Img2.default, {
        src: _close2.default
      }))), _react2.default.createElement(_IconContainer2.default, null, _react2.default.createElement(_Mark2.default, {
        size: size
      }, _react2.default.createElement(_Img2.default, {
        src: _check2.default
      }))))));
    }
  }]);

  return ExplicitCheckBox;
}(_react.Component);

ExplicitCheckBox.propTypes = {
  value: _propTypes2.default.oneOf(['yes', 'no', '']),
  onChange: _propTypes2.default.func,
  children: _propTypes2.default.node,
  size: _propTypes2.default.oneOf(['small', 'normal', 'large']),
  disabled: _propTypes2.default.bool,
  green: _propTypes2.default.bool
};
ExplicitCheckBox.defaultProps = {
  value: null,
  label: null,
  size: 'normal',
  disabled: false,
  green: false
};
exports.default = ExplicitCheckBox;